import { JOURNEY } from "../lib/plain-language";

/**
 * Trilha do fluxo principal, sempre visível para o usuário saber onde está:
 * criar → descrever → planejar → criar o sistema → ver → ajustar → publicar.
 */
export default function JourneySteps({
  current,
  className = "",
}: {
  /** índice da etapa atual (0 a 6) */
  current: number;
  className?: string;
}) {
  return (
    <ol className={`flex flex-wrap items-center gap-1 text-[11px] ${className}`}>
      {JOURNEY.map((label, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <li key={label} className="flex items-center gap-1">
            <span
              className={
                active
                  ? "rounded-full bg-brand px-2 py-0.5 font-medium text-brand-ink"
                  : done
                    ? "rounded-full border border-line px-2 py-0.5 text-ink"
                    : "rounded-full border border-dashed border-line px-2 py-0.5 text-ink-muted"
              }
            >
              {index + 1}. {label}
            </span>
            {index < JOURNEY.length - 1 && <span className="text-ink-muted">›</span>}
          </li>
        );
      })}
    </ol>
  );
}
